import { render, staticRenderFns } from "./LabelPDF.vue?vue&type=template&id=7948d5b4&scoped=true&"
import script from "./LabelPDF.vue?vue&type=script&lang=js&"
export * from "./LabelPDF.vue?vue&type=script&lang=js&"
import style0 from "./LabelPDF.vue?vue&type=style&index=0&id=7948d5b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7948d5b4",
  null
  
)

export default component.exports